// Copyright (c) 2020 Comsearch, Inc., All rights reserved

export default {
  data: [],
  selectedPricingGroupDef: null,
}
